import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';

import { sessionActions } from '../../../../store';

import type { AppDispatch } from '../../../../store';
import type { UseSaveGoalsProgressParams } from './types';

export function useSaveGoalsProgress({
  sessionId,
  values,
  goalsPracticedList,
  useNewUi,
}: UseSaveGoalsProgressParams) {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();

  const saveGoalsProgress = () => {
    return dispatch(
      sessionActions.updateProgressSynopsis({
        sessionId,
        data: {
          client_progress: values.client_progress,
          synopsis: values.synopsis,
          ...(useNewUi && {
            goal_techniques: Object.fromEntries(
              Object.entries(goalsPracticedList ?? {}).map(([goalId, goalData]) => [
                Number(goalId),
                goalData.techniques ?? [],
              ]),
            ),
            goal_timings: Object.fromEntries(
              Object.entries(goalsPracticedList ?? {}).map(([goalId, goalData]) => [
                Number(goalId),
                goalData.timings ?? [],
              ]),
            ),
          }),
        },
        getAccessTokenSilently,
      }),
    );
  };

  return saveGoalsProgress;
}
